<!-- global markup for header -->
<header class="header">
	<div class="content">
		<div class="header__block row">
			<div class="header__arrow col image" (click)="BackToAdmin()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>
			<div class="header__title col">{{ title$ | async }}</div>
			<div class="header__burger col image">
				<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
			</div>
		</div>
	</div>

	<!-- <div class="report-table__row" *ngIf="showSearch$ | async">
		<div class="header__search header__search_small" style="width: 99%; margin: auto; margin-top: 10px">
			<form [formGroup]="form">
				<input class="header__search-input" type="text" placeholder=" חפש לקוח" formControlName="ClientSearch" style="text-align: center" />
			</form>
			<button class="header__clear-icon" (click)="SearchClear()"></button>
		</div>
	</div> -->
</header>

<!-- start report table markup -->
<section class="report-table">
	<div class="content">
		<form [formGroup]="form" dir="rtl">
			<div class="info-row">
				<mat-form-field color="primary" class="datepicker">
					<mat-label>לפי תאריך</mat-label>
					<mat-date-range-input [rangePicker]="picker" [dateFilter]="dateFilterFunction" (click)="picker.open()">
						<input matStartDate formControlName="from" readonly="true" />
						<input matEndDate formControlName="to" readonly="true" />
					</mat-date-range-input>
					<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-date-range-picker #picker></mat-date-range-picker>
				</mat-form-field>
				<button mat-raised-button (click)="resetForm()" style="height: 50%; align-self: center" color="primary">הכל</button>

				<!-- <app-excel-button></app-excel-button> -->
				<div class="info-title">סה"כ: {{ totalSum | number : '1.0-2' : 'en-US' }}</div>
				<!-- <div class="info-title" *ngIf="(Second || Third) && currentlyViewedAgent">/ {{ currentlyViewedAgent }}</div>
				<div class="info-title" *ngIf="Third && currentlyViewedClientTeuda">/ {{ currentlyViewedClientTeuda }}</div> -->
			</div>
		</form>

		<app-tabulator-table
			*ngIf="isAdminPage"
			[rowToScrollTo]="_dohotBizoimSales.rowToScrollTo"
			[tableData]="adminData"
			[height]="tableHeight"
			(rowClick)="onRowClick($event)"
			(scrolledToRow)="onScrolledToRow()"
			[columnNames]="tabulatorColumns"
		></app-tabulator-table>

		<app-tabulator-table
			*ngIf="isAgentPage"
			[rowToScrollTo]="_dohotBizoimSales.rowToScrollTo"
			[tableData]="agentData"
			[height]="tableHeight"
			(rowClick)="onRowClick($event)"
			(scrolledToRow)="onScrolledToRow()"
			[columnNames]="tabulatorColumns"
		></app-tabulator-table>
	</div>
</section>

<!-- <router-outlet></router-outlet> -->
<!-- end report table markup -->
